"use strict";
export const TOPAZ_SOCIAL_URLS = {
  x: "https://x.com/TopazDex",
  telegram: "https://t.me/TopazDex",
  github: "https://github.com/topazdex"
};
export const TOPAZ_AUDIT_URL = "https://github.com/shieldify-security/audits-portfolio/blob/main/reports/Topaz-Dex-Security-Review.pdf";
